export default {"src":"/_next/static/media/news-1.f59f7da4.svg","height":62,"width":220,"blurWidth":0,"blurHeight":0};